export const iconFontAwesomeWeatherUmbrella = (
	<i className="fa-solid fa-umbrella"></i>
);
